import React from 'react';
import Footer from '../component/Footer';

const Clinic = () => {
    return (
        <>

            <div class="breadcrumb">
                <a href="/">Home</a> / Our Clinic
            </div>


            <div className="container mt-5">
                <div className="text-center">
                    <h1>About Our Clinic</h1>
                    <p className="lead">
                        A state-of-the-art facility providing exceptional care and advanced medical solutions.
                    </p>
                </div>

                <div className="row my-4">
                    <div className="col-md-6">
                        <h3>Our Vision</h3>
                        <p>
                            To be a leader in delivering compassionate, patient-centered care with cutting-edge technology
                            and expert medical staff. Our aim is to create a healthier and happier community.
                        </p>
                    </div>
                    <div className="col-md-6">
                        <h3>Our Services</h3>
                        <ul>
                            <li>General Consultation</li>
                            <li>Advanced Diagnostics</li>
                            <li>Specialty Treatment Centers</li>
                            <li>Wellness Programs</li>
                            <li>Telemedicine and E-Clinic Support</li>
                        </ul>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <h3>Why Choose Us?</h3>
                        <p>
                            Our clinic is known for its exceptional patient care, a team of renowned specialists,
                            and cutting-edge facilities. We prioritize your health and well-being, ensuring
                            personalized treatments and comprehensive care.
                        </p>
                    </div>

                </div>
            </div>

            <Footer />
        </>
    );
};

export default Clinic;
